import {
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
} from "@mui/material";
import React from "react";
import CloseIcon from '@mui/icons-material/Close';

export default function Popup(props) {
  const { title, children, openPopup, setOpenPopup, isMasterProduct, fullWidth, maxWidth, close = true, setIndex, setInputData, setErrors, hideDividers, dialogContentSx, headerActions } = props;

  const handle = () => {
    if (setIndex) {
      setIndex(() => "")
      setInputData({ user: "", note: "" })
      setErrors(() => "")
    }

  }
  return (
    <Dialog
      sx={{ ".MuiDialog-paper": { borderRadius: "10px", maxHeight: "calc(100vh - 20px)" } }}
      open={openPopup}
      maxWidth={maxWidth ? maxWidth : isMasterProduct ? "md" : "sm"}
      fullWidth={fullWidth}
      classes={{
        paper: {
          padding: "2px",
          position: "absolute",
          top: "5px",
          maxHeight: "calc(100vh - 20px)",
        },
      }
      }
      id={typeof title === "string" ? title : undefined}
    >
      <DialogTitle sx={{ paddingBottom: "0px", paddingTop: "7px" }}>
        <div style={{ display: "flex", alignItems: "center" }}>
          <Typography variant="h5" component="div" style={{ flexGrow: 1 }}>
            {title}
          </Typography>
          {headerActions}
          {
            close &&
            <IconButton
              disableRipple
              onClick={() => {
                setOpenPopup(false)
                handle()
              }}
              sx={{ m: 0, p: .5, pt: 0, "&:hover": { backgroundColor: "transparent" } }}
            >
              <CloseIcon color="action" />
            </IconButton>
          }
        </div>
      </DialogTitle>
      {hideDividers ? (
        <DialogContent sx={{
          padding: "15px",
          ...dialogContentSx
        }}>{children}</DialogContent>
      ) : (
        <DialogContent dividers sx={dialogContentSx}>{children}</DialogContent>
      )}

    </Dialog >
  );
}
